// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: Remove this comment and fix the code
import "reflect-metadata";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ApolloProvider } from "./apollo/contexts";
import { AlertsProvider } from "./contexts/alert/AlertsContext";
import { ProtectedRoute } from "./guards/ProtectedRoute";
import { AuthLayout } from "./layouts/AuthLayout";
import { RoutesPage } from "./constants/routes";
import { EmailLoginPage } from "./pages/login/Email";
import { ConfirmAuthChallenge } from "./pages/login/ConfirmAuthChallenge";
import { PasswordLoginPage } from "./pages/login/Password";
import { ConsentPage } from "./pages/consent/ConsentPage";
import { SetNewPassword } from "./pages/login/SetNewPassword";
import { AuthCallback } from "./pages/login/AuthCallback";
import { ForgotPasswordPage } from "./pages/login/ForgotPasswordPage";
import { AdminLayout } from "./layouts/AdminLayout";
import { UserManagement } from "./pages/admin/UserManagement";
import { CreateUser } from "./pages/admin/CreateUser";
import { AddUsers } from "./pages/admin/BulkUpload";
import { EditUser } from "./pages/admin/EditUser";
import { UpdateProfile } from "./pages/admin/UpdateProfile";

import "./styles/styles.css";
import { TermsOfServicePage } from "./pages/consent/TermsOfServicePage";
import { PrivacyPolicyPage } from "./pages/consent/PrivacyPolicyPage";
import { DashboardPage } from "./pages/Dashboard";

export const AppContent = () => {
  return (
    <Routes>
      <Route
        path={RoutesPage.TermsOfService}
        element={<TermsOfServicePage />}
      />
      <Route path={RoutesPage.PrivacyPolicy} element={<PrivacyPolicyPage />} />
      <Route element={<AuthLayout />}>
        <Route path={RoutesPage.Home} element={<EmailLoginPage />} />
        <Route path={RoutesPage.Login} element={<EmailLoginPage />} />
        <Route
          path={RoutesPage.LoginConfirm}
          element={<ConfirmAuthChallenge />}
        />

        <Route path={RoutesPage.Password} element={<PasswordLoginPage />} />
        <Route path={RoutesPage.ConsentModal} element={<ConsentPage />} />
        <Route path={RoutesPage.SetNewPassword} element={<SetNewPassword />} />
        <Route
          path={RoutesPage.ForgotPassword}
          element={<ForgotPasswordPage />}
        />
        <Route path={RoutesPage.AuthCallback} element={<AuthCallback />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route path={RoutesPage.Dashboard} element={<DashboardPage />} />
          <Route
            path={RoutesPage.UserManagement}
            element={<UserManagement />}
          />
          <Route path={RoutesPage.CreateUser} element={<CreateUser />} />
          <Route path={RoutesPage.AddUsers} element={<AddUsers />} />
          <Route path={RoutesPage.EditUser} element={<EditUser />} />
          <Route path={RoutesPage.UpdateProfile} element={<UpdateProfile />} />
          <Route path="*" element={<DashboardPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export const App = () => {
  return (
    <AlertsProvider>
      <Router>
        <ApolloProvider>
          <AppContent />
        </ApolloProvider>
      </Router>
    </AlertsProvider>
  );
};

export default App;
